<template>
  <b-table sticky-header="70vh" :no-border-collapse="true" responsive hover :fields="fields" :items="value">
    <template #cell(shop)="data">
      <span class="cap-smalled">{{ data.item.shopId }} - {{ data.item.shopName }}</span>
    </template>
    <template #cell(fullname)="data">
      {{ data.item.surname }}
      {{ data.item.name }}
    </template>
    <template #cell(birthDate)="data">
      {{ formatBirthDate(data.item.birthDate) }}
      <span class="cap-smalled"><br>{{ birthDatePlace(data.item.birthPlace) }}</span>
    </template>
    <template #cell(signedAt)="data">
      {{ formatSignedAt(data.item.signedAt) }}
    </template>
    <template #cell(procedureChoice)="data">
          <span :class="procedureStyle(data.item.procedureChoice)">
            {{ procedureDescription(data.item.procedureChoice) }}
          </span>
      <br>
      <span v-if="dataEntryModeShowPill(data.item.dataEntryMode)" :class="dataEntryModeStyle(data.item.dataEntryMode)">
            {{ dataEntryMode(data.item.dataEntryMode) }}
          </span>
      <br>
      <span v-show="data.item.warning" class="badge badge-pill badge-danger"> Segnalazione</span>
    </template>
    <template #cell(actions)="data">
      <b-row align-h="center" class="mr-2">
        <b-button-group>
          <b-button size="sm" title="Scarica adesione" v-b-tooltip.hover class="btn btn-primary" ref="download"
                    :href="`/api/memberships/${data.item.id}/signed_agreement`" target="_blank" v-show="(data.item.name !== null)">
            <b-icon icon="download" aria-hidden="true"></b-icon>
          </b-button>
          <b-button size="sm" @click="membershipDetails(data.item.id)" title="Dettaglio" v-b-tooltip.hover
                    variant="info" v-show="((data.item.name !== null))">
            <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
          </b-button>
          <b-button size="sm" v-if="canDelete" title="Elimina adesione" v-b-tooltip.hover class="btn-danger"
                    ref="delete"
                    @click="deleteMembership(data.item.id)">
            <b-icon icon="trash" aria-hidden="true"></b-icon>
          </b-button>
        </b-button-group>
      </b-row>
    </template>
  </b-table>
</template>

<script>
import MembershipApi from "../../api/MembershipApi";
import moment from 'moment'
import Translate from "@/Translate";
import Style from "@/Style";
import eventBus from "../../EventBus";

export default {
  name: "MembershipList",
  props: ["value", "canDelete"],
  data: () => ({
    memberships: [],
    found: {},
    fields: [
      {key: 'shop', label: 'Negozio'},
      {key: 'barcode', label: 'Codice tessera'},
      {key: 'fullname', label: 'Nominativo'},
      {key: 'birthDate', label: 'Data e Luogo di nascita', class: 'text-center'},
      {key: 'signedAt', label: 'Data di Firma', class: 'text-center'},
      {key: 'procedureChoice', label: 'Procedura e Origine', class: 'text-center'},
      {key: 'actions', label: '', class: 'text-right'}
    ]
  }),
  methods: {
    isEmpty(object) {
      return Object.keys(object).length === 0
    },
    birthDatePlace(birthPlace) {
      if (birthPlace.city == null && birthPlace.province == null && birthPlace.nation == null) return null
      return birthPlace.city != null ? birthPlace.city + ', ' + birthPlace.province : birthPlace.nation + ', ' + birthPlace.province
    },
    procedureDescription(procedureChoice) {
      return Translate.procedureChoice(procedureChoice)
    },
    procedureStyle(procedureChoice) {
      return Style.procedureStyle(procedureChoice)
    },
    dataEntryMode(dataEntryMode) {
      return Translate.dataEntryMode(dataEntryMode)
    },
    dataEntryModeStyle(dataEntryMode) {
      return Style.dataEntryModeStyle(dataEntryMode)
    },
    dataEntryModeShowPill(dataEntryMode){
      return Style.showDataEntryModePill(dataEntryMode)
    },
    formatBirthDate(date) {
      if (date == null) return null
      return moment(date).format("DD/MM/YYYY")
    },
    formatSignedAt(date) {
      return moment.utc(date).format("HH:mm") === "00:00"
        ? moment.utc(date).local().format("DD/MM/YYYY")
        : moment.utc(date).local().format("DD/MM/YYYY HH:mm")
    },
    deleteMembership(contractCode) {
      this.$bvModal.msgBoxConfirm('Sei sicuro di voler eliminare definitivamente l\'adesione senza possibilità di ripristino?', {
        title: 'Eliminazione Irreversibile',
        size: 'sm',
        headerBgVariant: 'dark',
        headerTextVariant: 'light',
        headerCloseVariant: 'light',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Conferma',
        cancelTitle: 'Annulla',
        cancelVariant: 'light',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(agreed => {
          if (agreed) {
            MembershipApi.delete(contractCode)
              .then(() => {
                this.value = this.value.filter(membership => membership.contractCode !== contractCode);
              })
              .catch(() => {
                window.alert("Errore nell'eliminazione dell'adesione")
              })
          }
        })
    },
    membershipDetails(id) {
      console.log(id)
      eventBus.$emit("membership-detail", id)
    },
  }
}
</script>

<style scoped>
</style>
